module.exports = __webpack_public_path__ + "static/media/new-singers.b4e80891.jpg";